export const GLOBAL_LOADING_EVENT = "sportodos:global-loading";

export function notifyGlobalLoading(delta: 1 | -1): void {
  if (typeof window === "undefined") return;

  window.dispatchEvent(new CustomEvent(GLOBAL_LOADING_EVENT, {
    detail: { delta },
  }));
}
